export const DEFAULT_TTL = 90 * 24 * 60 * 60;

export enum AllowTracking {
    UNKNOWN = 'unknown',
    IRRELEVANT = 'irrelevant',
    ALLOWED = 'allowed',
    DECLINED = 'declined',
}

export interface ParsedCampaignCookie {
    domain: string;
    expires: number;
    serialized: string;
}

export interface SavedCampaign {
    url: string;
    cookie: string;
    expires: number;
    allowTracking: AllowTracking;
}

export interface CampaignAnalytics {
    campaignUrl?: string;
    campaignCookie?: string;
}

export type SavedCampaignWatcher = (campaign: SavedCampaign | undefined) => void;

export type Destructor = () => void;
